import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-fullscreen',
  imports: [CommonModule],
  templateUrl: './fullscreen.html',
  styleUrl: './fullscreen.scss',
})
export class Fullscreen {
  fullscreenWindow = false;

  @HostListener('document:fullscreenchange')
  onFullscreenChange(): void {
    this.fullscreenWindow = !!document.fullscreenElement;
  }

  toggleFullscreen(): void {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => console.error('Error entering fullscreen:', err));
    } else {
      document.exitFullscreen().catch((err) => console.error('Error exiting fullscreen:', err));
    }
  }

}
